import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function QuestionHowWaterPlantsPage() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    navigate('/onboarding/question-care-reminders')
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.questionHowWaterPlants.heading')}
      buttons={[
        {
          text: t('pages.onboarding.questionHowWaterPlants.setSchedule'),
          value: 'set_schedule',
        },
        {
          text: t('pages.onboarding.questionHowWaterPlants.whenSoilDry'),
          value: 'when_soil_dry',
        },
        {
          text: t('pages.onboarding.questionHowWaterPlants.whenLooksThirsty'),
          value: 'when_looks_thirsty',
        },
        {
          text: t('pages.onboarding.questionHowWaterPlants.wheneverRemember'),
          value: 'whenever_remember',
        },
        {
          text: t('pages.onboarding.questionHowWaterPlants.notSure'),
          value: 'not_sure',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
